
module dg.objects {

    export class ObjectEditorController extends ObjectDisplayerController {
        public form: any;
    }

    angular.module('dg.objects').component('objectEditor', {
        bindings: {
            value: '<',
            exclude: '<',
            include: '<',
            form: '<'
        },
        transclude: true,
        controller: ObjectEditorController,
        templateUrl: '/digmo/src/objects/object-editor.html'
    });
}